// extracted by mini-css-extract-plugin
module.exports = {"headerText":"index_headerText_31ldX","user":"index_user_35Q7l"};